import {Image,Text, View} from "@react-pdf/renderer";

import styles from "@/utils/export/components/header/header.styles";
import {usePdfLabels} from "@/utils/export/utils/usePdfLabls";

import Logo from '../../utils/images/Logo_MAN_simple_black_RGB.png';

export default function Header({ isFull }: { isFull: boolean; }) {
    const { header, subtitleFull, subtitleTableOnly, dateHeader } = usePdfLabels();

    const getDateInfo = (title: string) => {
        return ( <View style={{ flexDirection: 'row' }}>
            {title && (
                <View style={{ minWidth: 80 }}>
                    <Text>
                        {title}
                        <Text>:</Text>
                    </Text>
                </View>
            )}
            <Text style={{ marginLeft: 5 }}>{new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</Text>
        </View>)
    }

    return (
        <View style={styles.top}>
            <View style={styles.left}>
                <View style={styles.title}>
                    <Text>{header}</Text>
                </View>
                <Text>{isFull ? subtitleFull : subtitleTableOnly}</Text>
                {getDateInfo(dateHeader)}
            </View>

            <View style={styles.right}>
                <View style={styles.logo}>
                    <Image src={Logo} />
                </View>
            </View>
        </View>
    );
}
